import React from 'react';
import Hero from '../components/Hero';
import PortfolioSections from '../components/PortfolioSections';

export default function Home() {
  return (
    <div className="relative w-full bg-[#0a0a0a] text-white selection:bg-white/20">
      <Hero />
      <PortfolioSections />
    </div>
  );
}
